import { defineMessages } from 'react-intl';
export const TIER_LABELS = defineMessages({
    monthly: {
        defaultMessage: 'Pay monthly',
        id: 'b3d4321dd0',
        description: 'Monthly message in the constants subscription section',
    },
    yearly: {
        defaultMessage: 'Pay yearly',
        id: 'd4f37f75ff',
        description: 'Yearly message in the constants subscription section',
    },
    unknown: {
        defaultMessage: 'Unknown',
        id: '2a94ceae61',
        description: 'Unknown message in the constants subscription section',
    },
});
export const TIER_DESCRIPTIONS = defineMessages({
    monthly: {
        defaultMessage: '{price} per month',
        id: '06ce0c18d8',
        description: 'Monthly message in the constants subscription section',
    },
    yearly: {
        defaultMessage: '{price} per year',
        id: '509c45dd0e',
        description: 'Yearly message in the constants subscription section',
    },
    unknown: {
        defaultMessage: 'Unknown',
        id: '2a94ceae61',
        description: 'Unknown message in the constants subscription section',
    },
});
export const UNSET_PAYMENT_METHOD_TYPE = 'unset';
export const CURRENCY = 'USD';
export const PROMO_CODE_URL_PARAM = 'discount_code';
export const DISCOUNT_CODE_MESSAGES = {
    RAMP: 'Welcome Ramp members. Your 6 month Perplexity Pro free trial starts now!',
    FREEATT: 'Welcome ATT Employees.  Your complimentary 1-year subscription starts now!',
    FREEAWS: 'Welcome AWS Employees.  Your complimentary 1-year subscription starts now!',
    RABBIT: 'Welcome r1 owners.  Your complimentary 1-year Perplexity Pro subscription starts now!',
    FREEUT: 'Welcome UT Staff.  Your complimentary 1-year Perplexity Pro subscription starts now!',
    FREEDATABRICKS: 'Welcome Databricks team.  Your complimentary 1-year Perplexity Pro subscription starts now!',
    FREESRA: 'Welcome SRA team. Your complimentary 1-year Perplexity Pro subscription starts now!',
    HBSTECH: 'Welcome HBS Tech Conference Attendees.  Your complimentary 6 month Perplexity Pro subscription starts now!',
    HBSSTAFF: 'Welcome HBS Tech Conference Attendees.  Your complimentary 1 year Perplexity Pro subscription starts now!',
    FREENEWSROOM: 'Welcome Friends!  Your complimentary 1-year Perplexity Pro subscription starts now!',
    FREEINKITT: 'Welcome Inkitt Writers!  Your complimentary 1-year subscription to Perplexity Pro starts now!',
    FREETIME: 'Welcome Time team!  Your complimentary 1-year subscription to Perplexity Pro starts now!',
    FREETMOBILE: 'Welcome T-Mobile team!  Your complimentary 1-year subscription to Perplexity Pro starts now!',
    '11LABS': 'Welcome! Your complimentary 3-month subscription to Perplexity Pro starts now!',
    FREECAVS: 'Welcome Cavs team! Your complimentary 1-year Perplexity Pro subscription starts now!',
    NOTHING6: 'Welcome Nothing owners. Your complimentary 6-month Perplexity Pro subscription starts now!',
    FREENOTHING6: 'Welcome Nothing owners. Your complimentary 6-month Perplexity Pro subscription starts now!',
    NOTHING1: 'Welcome Nothing owners. Your complimentary 1-year Perplexity Pro subscription starts now!',
    FREENOTHING1: 'Welcome Nothing owners. Your complimentary 1-year Perplexity Pro subscription starts now!',
    HOOHACKS: 'Welcome HooHacks Community. Your 1-year Perplexity Pro free trial starts now!',
    NJED: 'Welcome NJ ED Community. Your 1-year Perplexity Pro free trial starts now!',
    COPYAI: 'Welcome Copy AI customers! Your 6-month complimentary Perplexity Pro subscription starts now!',
    RAYCAST6: 'Welcome Raycast users! Your 6-month complimentary Perplexity Pro subscription starts now!',
    RAYCAST3: 'Welcome Raycast users! Your 3-month complimentary Perplexity Pro subscription starts now!',
    FREEMAGENTALOVE: 'Welcome Deutsche Telekom!  Your complimentary 1-year Perplexity Pro subscription starts now!',
    FREEPPLXVIP: 'Welcome friend of Perplexity! Your complimentary 1-year Perplexity Pro subscription starts now.',
    FREEUTA1: 'Welcome UTA team! Your complimentray 1-year Perplexity Pro subscription starts now.',
    DT: 'Willkommen Deutsche Telekom Kunde! Sie erhalten dank Magenta Moments ein kostenloses 1-Jahres-Abonnement für Perplexity Pro.',
    MY: 'Welcome! Your complimentary 1-year Perplexity Pro subscription starts now.',
};
export const TAX_INCLUSIVE_DISPLAY_COUNTRIES = ['KR'];
//# sourceMappingURL=constants.js.map